<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeEnd"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeEnd" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>
  </div>
</template>

<script>
import { Model } from "survey-core";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import { addClassQlEditorToSDDisplay, customThemeSurveyJS } from "../../../config/general-function";
import { mapState } from "vuex";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

export default {
  name: "MicrositeEnd",
  components: {
    Survey,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: null,
    survey: null,
    surveyJson: null,
    themeJson: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    await this.getCampaign();
    this.getSurveyAndTheme();

    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.end) {
        this.surveyJson = surveyJson.end;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).end;
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
  },
};
</script>

<style scoped>
/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
/* add-on */
::v-deep .sd-navigation__complete-btn {
  display: none;
}
::v-deep .sd-action-bar {
  display: none;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
